import { guideSetHoursThunkAction } from './setHours';
import { guideGenerateListThunkAction } from './generateList';

export const guideLoadDataThunkAction = ({
  start,
  stop,
  categoryHeight,
  channelHeight,
  categoryItemsMutator,
  fetchParams,
  setHoursParams,
}) => async (dispatch) => {
  await dispatch(
    guideGenerateListThunkAction({
      categoryHeight,
      channelHeight,
      categoryItemsMutator,
      fetchParams: {
        ...fetchParams,
        start,
        stop,
      },
    }),
  );

  await dispatch(
    guideSetHoursThunkAction({
      start,
      stop,
      ...setHoursParams,
    }),
  );
};
